import RaisedHands from '@assets/raised-hands.png';
import React from 'react';
import styled from 'styled-components';
import { Accordion, AccordionItem } from '../../../components/Accordion/Accordion';
import { media } from '../../../components/style-utils';
import { H3 } from '../../../components/Typography/Typography';

export const SectionFAQ = function() {
  return (
    <Container>
      <FaqRaisedHandsIcon src={RaisedHands} />
      <Headline>Here are answers to some common questions:</Headline>

      <FaqAccordion />
    </Container>
  );
};

const Container = styled.section`
  margin: 0;
  padding: 10rem 2rem;
  position: relative;
  width: 100vw;
`;

const FaqRaisedHandsIcon = styled.img`
  display: block;
  width: 10rem;
  margin: 0 auto;
  margin-bottom: 2.3rem;

  color: var(--colorPrimaryMedium);
  ${media.desktopAndUp`
    width: 13.6rem;
    margin-bottom: 3rem;
  `};
`;

const Headline = styled(H3)`
  font-weight: 500;
  text-align: center;
  color: var(--colorBlack);

  max-width: 14em;
  margin-left: auto;
  margin-right: auto;
`;

const Text = styled.p`
  color: var(--colorBlack);
  opacity: 0.8;
  margin: 1em 0;
`;

// Styled Accordion
const FaqAccordion = (props) => {
  return (
    <Accordion>
      <AccordionItem title="Why isn’t this cheaper?">
        <Text>
          The 167 is a very small mentorship program. I’ll be giving you unlimited access to both (myself) Brady and
          Alex for the full 12 weeks. We’ll be fully investing into you and your church. This level of personal coaching
          comes at a higher cost, otherwise, we’d have to start cutting corners and making concessions. Which we just
          aren’t willing to do with a program like this.
        </Text>
        <Text>
          I’m most excited to work with churches that highly value digital platforms and are ready to see their
          ministries thrive online.
        </Text>
      </AccordionItem>
      <AccordionItem title="How in-depth is the mentorship portion of the program?">
        <Text>
          That’s entirely up to you! Here’s how it works...Firstly, you’ll be given a private email address that you
          will use for all 1-on-1 mentorship. This is a direct line to myself (Brady) and Alex. And there’s no limit on
          how often you can use this - you’ve got unlimited email access.
        </Text>
        <Text>
          Secondly, we’ll be hosting weekly live calls to talk face-to-face, answer questions, and explore topics at
          deeper levels.
        </Text>
        <Text>Finally, there’s the insiders group. Here you’ll rub shoulders with the other churches in The 167.</Text>
      </AccordionItem>
      <AccordionItem title="What happens after the 12 weeks are up? Does my access expire?">
        <Text>
          Once your 12-week mentorship is complete, you’ll retain lifetime access to all course curriculum and
          materials. Meaning, when future classes progress through The 167 and we add more training, you’ll get instant
          access to all of that as well.
        </Text>
        <Text>
          You’ll also still be invited to live calls. And look, if you need to send us an email every so often - that’s
          totally fine as well :) We’re committed to your church’s success over the long-term. So even after the initial
          12-week sprint is over, we’ll always have your back.
        </Text>
      </AccordionItem>
      <AccordionItem title="Is my church too small for this?">
        <Text>No. In fact, the aim of The 167 mentorship program is the average, every day church.</Text>
        <Text>
          Why? Think about it this way...if you are highly influential, big church - your online attendance likely
          dwarfs your in-person attendance. You might have 10,000 people attend your church in-person each week, but
          have 500,000 watch the message online. This is a completely different paradigm than the average church - and
          thus, requires a much different content strategy.
        </Text>
        <Text>
          The 167 mentorship program won’t teach you how to do social like a megachurch. Because that wouldn’t be smart.
          Especially because the average church can do so much more on social when it comes to pastoral care and
          personal engagement than a bigger church can.
        </Text>
        <Text>
          The first step? Moving beyond the limiting mindset that says, “Must be nice. But my church is too small for
          that.” Focus on your strengths. Stop dwelling on what you think you lack.
        </Text>
      </AccordionItem>
      <AccordionItem title="Is this different from Nucleus Social?">
        <Text>
          Nucleus Social is a done-for-you social media platform. If Nucleus is akin to getting takeout for dinner, The
          167 mentorship is becoming a polished cook.
        </Text>
        <Text>
          At its best, Nucleus Social is a tool in your toolbox. A library of posts to pick and choose from and
          supplement your own social posts. The 167 is about teaching and training your church to become confident
          content creators yourself.
        </Text>
      </AccordionItem>
      <AccordionItem title="Does The 167 cover [insert topic here]?">
        <Text>
          The best part about being enrolled in the inaugural class of The 167 is that you’ll get a big say in what we
          cover. Beyond the core curriculum, if you want to see training on a specific topic, just let us know. It will
          be your voice calling the shots on the content we create.
        </Text>
      </AccordionItem>
      <AccordionItem title="Can I just enroll in a single module?">
        <Text>
          Not right now. In the future, we may explore different plans for The 167 - but we want to take every church in
          the inaugural class through the full mentorship experience.
        </Text>
      </AccordionItem>
      <AccordionItem title="What resources will I need to complete this program?">
        <Text>You’ll need access to an Internet-connected device. Beyond that, nothing else is required.</Text>
      </AccordionItem>
      <AccordionItem title="What if this program doesn’t work out for my church?">
        <Text>
          We’re fully committed to your church’s success. That’s why The 167 mentorship program comes with a 30-day
          guarantee. If you’re not satisfied with the program in any way in the first 30 days, we’ll offer you a 100%
          refund on your purchase. It’s as easy as that.
        </Text>
      </AccordionItem>
      <AccordionItem title="Why now?">
        <Text>
          I’m a big believer in the idea that unexpected problems create unprecedented opportunities. The church is
          having a moment right now and many of us are waking up to the power of digital platforms for the first time.
        </Text>
        <Text>
          The amount of opportunity that exists in the 167 hours beyond your Sunday service is immense. Not to replace
          in-person gatherings, but to contribute to your church accomplishing its biggest goals - whatever those may
          be.
        </Text>
        <Text>
          This is a watershed moment for the church. And for those ready to take the plunge, we’re ready to take the
          leap with you.
        </Text>
      </AccordionItem>
    </Accordion>
  );
};



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionFAQ.js